<template>
  <div class="order-card">
    <div class="row">
      <div class="col-12">
        <div
          v-if="messages.length"
          class="chat-window"
        >
          <perfect-scrollbar
            ref="scrollbar"
            :options="{wheelPropagation: false, wheelSpeed: '0.3'}"
          >
            <div
              v-for="(item, index) in messages"
              :key="index"
              class="message"
              :class="{'self-message': item.is_player}"
            >
              <div class="chat-avatar">
                <img
                  v-if="item.avatar"
                  :src="item.avatar"
                  alt=""
                >
                <div v-else>
                  <i class="icon icon-user" />
                </div>
              </div>
              <div class="chat-text">
                <div class="chat-name">
                  {{ item.is_player ? 'You' : item.name || 'Client' }}
                </div>
                {{ item.msg }}
              </div>
            </div>
          </perfect-scrollbar>
        </div>
        <div v-else>
          Messages not found
        </div>
      </div>
      <div
        v-if="allowSend"
        class="col-12"
      >
        <div class="chat-form">
          <input
            v-model="inputMessage"
            type="text"
            class="chat-input"
            :disabled="!allowSend"
            placeholder="You message..."
            @keyup.enter="send"
          >
          <v-btn
            dark
            large
            :disabled="!allowSend"
            @click="send"
          >
            Send
          </v-btn>
        </div>
      </div>
    </div>
    </z-card>
  </div>
</template>

<script>

export default {
  props: {
    messages: {
      type: Array,
      default: () => [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    allowSend: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    inputMessage: '',
  }),

  methods: {
    send() {
      this.$emit('send', this.inputMessage);
      this.inputMessage = '';
    },

    scrollBottom() {
      if (this.messages.length === 0) return;

      this.$nextTick(() => {
        this.$refs.scrollbar.$el.scrollTop = this.$refs.scrollbar.$el.scrollHeight + 100;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-window {
  min-height: 200px;
  margin: 0 -15px;
}

.ps {
  height: 350px;
}

h2 {
  width: 100%;
  text-align: center;
  color: var(--color-secondary);
  font-family: var(--font-bold);
  font-size: 24px;
  padding: 0;
  margin: 0;
  padding-bottom: 30px;
}

.chat-form {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dedede;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: -20px;
  padding: 30px;
}

.chat-input {
  flex-grow: 1;
  height: 48px;
  margin-right: 20px;
  border-radius: 10px;
  outline: none;
  background: var(--color-white);
  border: 1px var(--color-white) solid;
  padding: 20px;
  transition: 0.2s;

  &:focus {
    border-color: #a9a9a9;
  }
}

.message {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 0 15px;

  .chat-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    min-width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #ececec;

    .icon {
      font-size: 20px;
      position: relative;
      top: 2px;
      opacity: 0.5;
    }

    img {
      width: 44px;
      height: 44px;
      border-radius: 50%;
    }
  }

  .chat-name {
    color: var(--color-secondary);
    font-family: var(--font-bold);
    text-transform: uppercase;
    font-size: 12px;
  }

  .chat-text {
    background: #ececec;
    border-radius: 10px;
    padding: 10px;
    width: 70%;
  }

  &.self-message {
    flex-direction: row-reverse;

    .chat-avatar {
      margin-right: 0;
      margin-left: 10px;
      min-width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #272727;
    }

    .icon {
      font-size: 20px;
      position: relative;
      top: 2px;
      opacity: 0.3;
      color: #fff;
    }

    .chat-text {
      background: #272727;
      color: #fff;
    }
  }
}
</style>
